import React from "react";
import { Glyphicon, OverlayTrigger, Popover } from "react-bootstrap";
import Profile from "./Profile";

export default class ProfileOverlay extends React.Component {
    render() {
        const { container, location } = this.props

        const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";
        return !IS_BIRD_APP ? (
            <div className="user-profile-container">
              <OverlayTrigger
                container={container}
                trigger="click"
                placement="left"
                rootClose
                overlay={
                  <Popover title="My Profile" id={"user-profile"}>
                    <Profile pathName={location.pathname} />
                  </Popover>
                }
              >
                <Glyphicon glyph="cog" />
              </OverlayTrigger>
            </div>
          ) : null
    }
}